import { render } from "./modal-tree.vue?vue&type=template&id=21334ee4&scoped=true"
import script from "./modal-tree.vue?vue&type=script&lang=js"
export * from "./modal-tree.vue?vue&type=script&lang=js"

import "./modal-tree.vue?vue&type=style&index=0&id=21334ee4&scoped=true&lang=css"

import exportComponent from "/Users/simon/www/earth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21334ee4"]])

export default __exports__